import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
const pad = (n: number) => String(n).padStart(2, "0");
export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Minutes"
  }, {
    value: seconds,
    label: "Seconds"
  }];
  return <div className="mt-8 text-center" role="timer" aria-live="off" data-id="element-19" data-mp="3c1crmsyxaarf">
      <p className="flex items-center justify-center gap-2 text-[13px] font-bold uppercase tracking-wider text-berry" data-id="element-20" data-mp="3c48p6g6uyxfc">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-21" data-mp="323yd4ywk7w1r" />
        This special offer ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-22" data-mp="3729lf577hyhv">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-23" data-mp="10btqa1tx3oxw" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-24" data-mp="10cv062z765e1">
              <span className="flex h-[68px] w-[68px] items-center justify-center rounded-xl bg-berry font-serif text-[34px] font-bold tabular-nums text-white shadow-[0_8px_20px_-10px_rgba(163,51,90,0.8)]" data-id="element-25" data-mp="15by6dqqwyhnl">
                {pad(u.value)}
              </span>
              <span className="mt-1.5 text-[11px] font-semibold uppercase tracking-wider text-muted" data-id="element-26" data-mp="szzcr9w0l4ji">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className="pt-4 font-serif text-3xl font-bold text-berry" aria-hidden="true" data-id="element-27" data-mp="12sewabmym16i">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}